import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { useState, SyntheticEvent } from 'react';
import arrowSvg from '@/assets/svg/arrow.svg';
import {
  LIRPReport,
  StyledAccordion,
  AccordionTitle,
} from '@/components/AccordionSection/AccordionSection.styles';
import { RichText } from '@/components/RichText/RichText';

interface AccordionSectionProps {
  items: { title: string; text: string }[];
  to: string;
}

export const AccordionSection = ({ items, to }: AccordionSectionProps) => {
  const [expanded, setExpanded] = useState<string | false>('panel0');

  const handleChange = (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const hasLIRP = (title: string) => typeof title === 'string' && title.includes('LIRP');

  if (!items) {
    return <p>No Background</p>;
  }

  return (
    <>
      {items
        .filter((item) => item.title && item.title !== 'na' && item.text && item.text !== 'na')
        .map((item, index) => (
          <StyledAccordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={<img src={arrowSvg} />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <AccordionTitle isExpanded={expanded === `panel${index}`}>
                {item.title}
              </AccordionTitle>
            </AccordionSummary>
            <AccordionDetails>
              {/* component="div": RichText renders its own <p> per paragraph and
                  Typography's default <p> may not contain another <p>. */}
              <Typography component="div">
                <RichText text={item.text} />
              </Typography>
              {hasLIRP(item.title) && (
                <Typography>
                  <LIRPReport href={to} target="_blank">
                    LIRP REPORT
                  </LIRPReport>
                </Typography>
              )}
            </AccordionDetails>
          </StyledAccordion>
        ))}
    </>
  );
};
